export const COLORS = [
  'neutral',
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'error',
] as const;

export type ColorType = (typeof COLORS)[number];
